import * as React from "react"
import { Paper, Seo } from "components"

interface BusinessPage {
	//
}

const BusinessPage: React.FC<BusinessPage> = () => {
	return (
		<>
			<Seo
				title="آنتی ویروس سازمانی (تحت شبکه)"
				description="خرید نسخه تحت شبکه آنتی ویروس‌های ایی‌ست، کسپرسکی، آویرا و بیت دیفندر از مرجع آنتی ویروس ایران"
				path="/shop/business"
			/>
			<Paper className="p-5 text-center">
				<h4>صفحه‌ مورد نظر در دست احداث می‌باشد.</h4>
			</Paper>
		</>
	)
}

export default BusinessPage
